import { useState } from "react";
import { Button, Card, Input, Stack, Text } from "@/components/ui";
import { useCambiarCelular } from "../hooks/use-usuarios-mutations";

const E164 = /^\+[1-9]\d{7,14}$/;

/** Celular E.164 del usuario (canal SMS/WhatsApp de notificaciones). Vacío = sin celular. */
export function SeccionCelular({ usuarioId, celularActual }: { usuarioId: string; celularActual: string | null }) {
  const [valor, setValor] = useState(celularActual ?? "");
  const guardar = useCambiarCelular();

  const normalizado = valor.replace(/[\s\-()]/g, "");
  const invalido = normalizado.length > 0 && !E164.test(normalizado);
  const sinCambios = normalizado === (celularActual ?? "");

  return (
    <Card padding="md">
      <Stack gap="sm">
        <Text size="xs" fw={600} className="uppercase tracking-wide" c="dimmed">
          Celular
        </Text>
        <Input
          size="sm"
          type="tel"
          value={valor}
          onChange={(e) => setValor(e.currentTarget.value)}
          placeholder="+525512345678"
          aria-label="Celular del usuario"
          error={invalido ? "Formato E.164: +52 y 10 dígitos" : undefined}
        />
        <Button
          size="xs"
          fullWidth
          loading={guardar.isPending}
          disabled={sinCambios || invalido}
          onClick={() => guardar.mutate({ usuarioId, celular: normalizado === "" ? null : normalizado })}
        >
          Guardar celular
        </Button>
      </Stack>
    </Card>
  );
}
